import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
  backdrop-filter: blur(10px);
`;

const Logo = styled(Link)`
  font-family: 'Playfair Display', serif;
  font-size: 1.8rem;
  font-weight: 700;
  color: #333;
  text-decoration: none;
  
  span {
    color: #6c5ce7;
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 2rem;
  
  @media (max-width: 768px) {
    display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
    flex-direction: column;
    position: absolute;
    top: 80px;
    left: 0;
    right: 0;
    background: white;
    padding: 2rem;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
  }
`;

const NavLink = styled(Link)`
  color: #333;
  text-decoration: none;
  font-weight: 500;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    width: ${({ active }) => (active ? '100%' : '0')};
    height: 2px;
    bottom: -5px;
    left: 0;
    background-color: #6c5ce7;
    transition: width 0.3s ease;
  }
  
  &:hover:after {
    width: 100%;
  }
`;

const MenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  
  @media (max-width: 768px) {
    display: block;
  }
`;

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setIsOpen(false);
    }, [location]);

    return (
        <Nav>
            <Logo to="/">
                <motion.span
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5 }}
                >
                    Ngalonde <span>Connect</span>
                </motion.span>
            </Logo>

            <MenuButton onClick={() => setIsOpen(!isOpen)}>
                {isOpen ? '✕' : '☰'}
            </MenuButton>

            <NavLinks isOpen={isOpen}>
                <NavLink to="/" active={location.pathname === '/' ? 1 : 0}>Home</NavLink>
                <NavLink to="/events" active={location.pathname === '/events' ? 1 : 0}>News & Events</NavLink>
                <NavLink to="/history" active={location.pathname === '/history' ? 1 : 0}>History</NavLink>
                <NavLink to="/heritage" active={location.pathname === '/heritage' ? 1 : 0}>Heritage</NavLink>
                <NavLink to="/businesses" active={location.pathname === '/businesses' ? 1 : 0}>Businesses</NavLink>
                <NavLink to="/documents" active={location.pathname === '/documents' ? 1 : 0}>Documents</NavLink>
                <NavLink to="/contact" active={location.pathname === '/contact' ? 1 : 0}>Contact</NavLink>
            </NavLinks>
        </Nav>
    );
};

export default Navbar;